module.exports = __webpack_public_path__ + "static/media/about.830b6731.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/about.jpg
// module id = 658
// module chunks = 0